export default __webpack_public_path__ + "static/media/play-store.688587b0.svg";